import {
  type InteractionStatus,
  type ReferralAgent,
  type ReferralAgentRaw,
  type ReferralAgentSummaryRaw,
  TransactionStatusExternal,
  TransactionStatusMissing,
} from '@/common/hooks/referrals/types';

type AgentLike = ReferralAgent | ReferralAgentRaw | ReferralAgentSummaryRaw;

export function getCompanyName(agent: AgentLike) {
  const companyName = agent?.brokerage?.companyName ?? '';
  const teamName = agent?.teamName ?? '';

  return `${teamName.length ? teamName : companyName}`;
}

export function getStatusOfInteractionOnReferral({
  interaction,
  transactingAgent,
}: {
  interaction: { status: InteractionStatus | null };
  transactingAgent?: { isSideAgent?: boolean };
}): InteractionStatus {
  if (!transactingAgent?.isSideAgent) {
    return TransactionStatusExternal;
  }

  if (!interaction.status) {
    return TransactionStatusMissing;
  }

  return interaction.status;
}
